var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.meta != null && _vm.$route.meta.keepAlive)?_c('keep-alive',{key:_vm.$route.name},[_c('router-view')],1):_c('router-view',{key:_vm.$route.name})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }